<template>
  <div>
    <el-dialog
      class="edit-dialog hide-header"
      :title="title"
      ref="ruleForm"
      :visible.sync="dialogFormVisible"
      @close="treeCallback"
    >
      <div class="content">
        <div v-for="(condition, i) in conditions" :key="i">
          <div class="con-title">
            <span>{{ condition.title }}</span>
          </div>
        </div>
      </div>

      <div>
        <el-tree
          ref="tree"
          :props="props"
          :load="loadNode"
          lazy
          show-checkbox
          node-key="code"
          :default-checked-keys="checkList"
          @check-change="handleCheckChange"
        ></el-tree>
      </div>

      <div slot="footer" class="dialog-footer" v-for="(condition, i) in conditions" :key="i">
        <el-button type="primary" v-show="condition.visible" @click="saveCallback()">保存</el-button>
        <el-button type="primary" v-show="condition.visible" @click="treeCallback">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TreeDialog',
  props: {
    treeVisible: {
      type: Boolean,
      required: true
    },
    conditions: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: '树形结构弹窗'
    },
    row: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: () => {}
    },
    customerEdit: {
      type: Boolean,
      default: false
    },
    // expandList: {
    //   type: Array,
    //   default: () => [],
    //   required: true,
    // },
    checkList: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data () {
    return {
      popedomArr: [],
      popedomObj: {},
      dialogFormVisible: this.treeVisible,
      props: {
        label: 'name',
        children: 'zones'
      },
      count: 1,
      form: {}
    };
  },
  methods: {
    treeCallback () {
      this.$emit('update:treeVisible', false);
    },
    saveCallback () {
      this.$emit('saveCallback', this.popedomArr);
    },
    handleCheckChange (data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      // console.log(this.$refs.tree.getCheckedKeys(false));
      // console.log(this.$refs.tree.getHalfCheckedKeys(true));
      // console.log(this.$refs.tree.getHalfCheckedNodes(true));
      // console.log(this.$refs.tree.getCurrentKey(true));
      // console.log(this.checkList);
      // if (checked) {
      //   if (data.hasNext === false) {
      //     this.popedomArr.push(data.code);
      //   }
      // }
      // this.popedomArr = new Array;
      this.popedomArr = [];
      var list = this.$refs.tree.getCheckedNodes(false, false);
      console.log(list);
      list.forEach((item, index) => {
        var hasNext = item.hasNext;
        if (hasNext) {
          item.childEntity.forEach((childItem, index) => {
            var childHasNext = childItem.hasNext;
            if (childHasNext) {
              childItem.childEntity.forEach((secChildItem, index) => {
                this.popedomArr.push(secChildItem.code);
              });
            } else {
              this.popedomArr.push(childItem.code);
            }
          });
        } else {
          this.popedomArr.push(item.code);
        }
      });
    },
    handleNodeClick (data, node, resolve) {
      console.log(data);
    },
    loadNode (node, resolve) {
      let arr = [];
      if (node.level === 0) {
        this.treeData.forEach((v, i) => {
          let obj = {};
          obj.id = 1;
          obj.name = v.name;
          obj.code = v.code;
          obj.disabled = this.disabled;
          obj.hasNext = v.hasNext;
          obj.childEntity = v.childEntity;
          arr.push(obj);
          // this.expandList.push(obj);
        });
        return resolve(arr);
      }
      // let lastArr = [];
      // if (node.level === 3) {
      //   this.treeData.forEach((v, i) => {
      //     let lastObj = {};
      //     lastObj.popedomName = v.popedomName;
      //     lastObj.popedomId = v.popedomId;
      //     lastArr.push(lastObj);
      //   });
      //   return resolve(lastArr);
      // }
      if (node.level > 3) return resolve([]);
      var hasChild;
      if (node.data.hasNext) {
        hasChild = true;
      } else if (node.data.hasNext === false) {
        hasChild = false;
      } else {
        hasChild = Math.random() > 0.5;
      }
      setTimeout(() => {
        var data;
        if (hasChild) {
          node.data.childEntity.forEach((v, i) => {
            v.id = i;
            // this.expandList.push(v);
            v.disabled = this.disabled;
            if (this.disabled) {
              this.checkList.push(v.id);
            } else {
              this.checkList.push();
            }
          });
          data = node.data.childEntity;
        } else {
          data = [];
        }
        resolve(data);
      }, 5);
    }
  },
  created () {
    this.treerow = this.$deepClone(this.row);
    this.treeData = this.$deepClone(this.data);
    this.treeDisabled = this.$deepClone(this.disabled);
  }
};
</script>
<style>
.tree-dialog .el-dialog__body {
  border-bottom: 1px #eceaea solid !important;
  padding: 60px 20px !important;
}
.tree-dialog .el-button {
  padding: 10px 30px;
}
.el-form-item__content {
  text-align: left;
}
.edit-dialog.hide-header .el-dialog__header {
  display: none;
}
</style>

<style lang='scss' scoped>
.con-title {
  text-align: left;
  margin-bottom: 10px;
  span {
    border-bottom: 2px #409eff solid;
    line-height: 30px;
    padding: 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/page/TreeDialog.vue